import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import {Utils} from 'src/app/shared/utils/generics.utils';
import {inject} from "@angular/core";
import {DeviceType, getDeviceType, isDesktop} from "../../../shared/utils/ui.utils";

export const DeviceTypeGuard: CanActivateFn = (route: ActivatedRouteSnapshot,
                                               state: RouterStateSnapshot) => {

  const FLEET_KEY = 'fleet';
  const DEFAULT_FLEET = 'public';
  const NOT_SUPPORTED_URI = 'not-supported';
  const OWN_REDIRECT_URI = 'landing';
  const EMBEDDED_KEY = 'embedded';
  const LANGUAGE_KEY = 'lang';
  const REDIRECT_URL = 'redirectURL'

  const fleet = route.paramMap.get(FLEET_KEY) || DEFAULT_FLEET;
  const embedded = route.queryParamMap.get(EMBEDDED_KEY);
  const lang = route.queryParamMap.get(LANGUAGE_KEY);

  const router = inject(Router);
  const allowedTypes = route.data['allowedTypes'] as DeviceType[] || [];
  const deviceType = getDeviceType();

  if (allowedTypes.includes(deviceType)) {
    return true;
  }

  if (deviceType === DeviceType.DESKTOP) {
    return router.createUrlTree([`/${NOT_SUPPORTED_URI}`], {
      queryParams: {
        redirectURL: `${Utils.getDomain()}/#${state.url}`,
        embedded,
        lang
      }
    })
  }

  const redirectUrl = route.queryParamMap.get(REDIRECT_URL)?.split('#')[1];
  return router.createUrlTree([redirectUrl ? redirectUrl : `${fleet}/${OWN_REDIRECT_URI}`], {queryParams: route.queryParams});
}

